import ServiceBase from '../../ServiceBase';
import coveredWarrantProxy from '../../../proxies/market/watchlist/CoveredWarrantProxy';
import { ChanelConfig } from './../../../../configs/GlobalConfig';

class CoveredWarrantService extends ServiceBase {
  getCoveredWarrants(params, source) {
    return this.processSubscription(data => this.extractCWChannels(data))(() =>
      this.getData(() =>
        coveredWarrantProxy.getCoveredWarrants(params, source),
      ),
    );
  }

  getCoveredWarrantWatchlist(params) {
    return this.processSubscription(data => this.extractCWChannels(data))(() =>
      this.getData(() =>
        coveredWarrantProxy.getCoveredWarrantWatchlist(params),
      ),
    );
  }

  extractCWChannels(data) {
    var res = [];

    for (var cw of data.items) {
      res.push(this.getSubscribtionChannel(cw.coveredWarrantCode));
    }

    return res;
  }
}

const coveredWarrantService = new CoveredWarrantService();
export default coveredWarrantService;
